
class ModalBasket {
  constructor(event) {
    this.event = event;

    if (event.detail) {
      return;
      // this.addedExternal = event.detail.productId;
      // this.addedQuantity = event.detail.quantity;
    }

    this.init();
  }

  init() {
    const instance = this;
    const link = document.createElement('a');
    let url = '/basket/modal';
    if (this.addedExternal && this.addedQuantity) {
      url += `?product=${this.addedExternal}&quantity=${this.addedQuantity}`
    }
    link.href = url;

    this.modal = new Modal(link, {
      closerText: '',
      theme: '_right-position _inner-closer',
      onAfterStart: () => instance.initElements(),
    });
  }

  initElements() {
    const instance = this;
    this.modalBasket = document.querySelector('[data-modal-basket]');

    this.currentItems = Array.from(this.modalBasket.querySelectorAll('[data-items] [data-modal-basket-item]'))
      .map((item) => new ModalBasketItem(item));

    if (this.addedExternal) {
      this.addedProduct = new ModalBasketItem(this.modalBasket.querySelector('[data-added-product] [data-modal-basket-item]'));
      this.equalAdded = this.currentItems.find((item) => item.productId === instance.addedProduct.productId);

    }

    this.toOrderButton = this.modalBasket.querySelector('[data-to-order]');
    this.cancelButton = this.modalBasket.querySelector('[data-cancel]');

    this.totalPrice = this.modalBasket.querySelector('[data-total-price]');
    this.totalOldPrice = this.modalBasket.querySelector('[data-total-old-price]');

    this.csrfParam = document.querySelector('meta[name="csrf-param"]').getAttribute('content');
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    this.bind();
  }

  bind() {
    this.bindAdded();
    this.bindItems();
    this.bindButtons();
  }

  bindAdded() {
    if (!this.addedProduct) {
      return;
    }

    const instance = this;

    this.addedProduct.quantityInput.addEventListener('change', (e) => {
      instance.setAddedQuantity(e.target.value);
      instance.updateProductCountsInBackground();
    });

    this.addedProduct.minus.addEventListener('click', (e) => {
      e.preventDefault();
      if (instance.addedProduct.getQuantity() <= 0) {
        return;
      }
      instance.dec(this.addedProduct, (instance, response) => instance.updateAdded(response));
      instance.updateProductCountsInBackground();
    });

    this.addedProduct.plus.addEventListener('click', (e) => {
      e.preventDefault();
      instance.inc(this.addedProduct, (instance, response) => instance.updateAdded(response));
      instance.updateProductCountsInBackground();
    });

    this.addedProduct.remove.addEventListener('click', (e) => {
      e.preventDefault();
      instance.removeAdded();
      instance.updateProductCountsInBackground();
    });
  }


  bindItems() {
    const instance = this;
    this.currentItems.forEach((item) => {
      item.quantityInput.addEventListener('change', (e) => {
        instance.updateProductCountsInBackground();
        instance.setAlreadyQuantity(item, e.target.value);
      });

      item.minus.addEventListener('click', (e) => {
        e.preventDefault();
        if (item.getQuantity() <= 0) {
          return;
        }
        instance.dec(item, (instance, response) => instance.updateAlready(item, response));
        instance.updateProductCountsInBackground();
      });

      item.plus.addEventListener('click', (e) => {
        e.preventDefault();
        instance.inc(item, (instance, response) => instance.updateAlready(item, response));
        instance.updateProductCountsInBackground();
      });

      item.remove.addEventListener('click', (e) => {
        e.preventDefault();
        instance.removeAlready(item);
        instance.updateProductCountsInBackground();
      });
    })
  }

  async setAlreadyQuantity(item, quantity) {
    quantity = parseFloat(quantity);
    quantity = quantity ? quantity : 0;
    if (!quantity) {
      return;
    }

    if (this.equalAdded && this.equalAdded.productId === item.productId) {
      quantity += this.addedProduct.getQuantity();
    }
    this.setQuantity(quantity, item, (instance, response) => instance.updateAlready(item, response));
  }

  async setAddedQuantity(quantity) {
    quantity = parseFloat(quantity);
    quantity = quantity ? quantity : 0;
    if (!quantity) {
      return;
    }

    if (this.equalAdded) {
      quantity += this.equalAdded.getQuantity();
    }

    this.setQuantity(quantity, this.addedProduct, (instance, response) => instance.updateAdded(response));
  }

  bindButtons() {
    const instance = this;
    this.cancelButton.addEventListener('click', (e) => {
      e.preventDefault();
      instance.modal.close();
    });
  }

  async removeAdded() {
    if (this.equalAdded) {
      await this.setQuantity(this.equalAdded.getQuantity(), this.addedProduct, (instance, response) => {});
      this.equalAdded = null;
    } else {
      await this.remove(this.addedProduct, (instance, response) => {})
    }

    this.addedProduct.delete();
  }

  async removeAlready(item) {
    if (this.equalAdded && this.equalAdded.productId === item.productId) {
      await this.setQuantity(this.addedProduct.getQuantity(), this.addedProduct, (instance, response) => {});
      this.equalAdded = null;
    } else {
      await this.remove(item, (instance, response) => {});
    }

    item.delete();
  }

  async remove(item, callback) {
    item.disable();
    const response = await this.request(`${window.location.origin}/basket/` + item.external, {}, 'DELETE');
    callback(this, response);
    this.updateTotal(response);
  }

  async inc(item, callback) {
    item.disable();
    const response = await this.request(`${window.location.origin}/basket/plus/` + item.external);
    callback(this, response);
    this.updateTotal(response);
    item.enable();
  }

  async dec(item, callback) {
    item.disable();
    const response = await this.request(`${window.location.origin}/basket/minus/` + item.external);
    callback(this, response);
    this.updateTotal(response);
    item.enable();
  }

  async setQuantity(quantity, item, callback) {
    if (quantity) {
      item.disable();
      const response = await this.request(`${window.location.origin}/basket/count/` + item.external, { count: quantity});
      callback(this, response);
      this.updateTotal(response);
      item.enable();
    }
  }

  updateAdded(response) {
    if (this.equalAdded) {
      const price = response.item_total / response.item_amount;
      const oldPrice = response.item_nodiscount_total / response.item_amount;
      const newAmount = response.item_amount - this.equalAdded.getQuantity();

      response.item_amount = newAmount;
      response.item_total = price * newAmount;
      response.item_nodiscount_total = oldPrice * newAmount;
    }

    this.updateItem(this.addedProduct, response);
  }

  updateAlready(item, response) {
    if (this.equalAdded && this.equalAdded.productId === item.productId) {
      const price = response.item_total / response.item_amount;
      const oldPrice = response.item_nodiscount_total / response.item_amount;
      const newAmount = response.item_amount - this.addedProduct.getQuantity();

      response.item_amount = newAmount;
      response.item_total = price * newAmount;
      response.item_nodiscount_total = oldPrice * newAmount;

      response.item_amount = newAmount;
    }

    this.updateItem(item, response);
  }

  updateItem(item, data) {
    item.setQuantity(data.item_amount);
    item.setPrice(data.item_total);
    item.setOldPrice(data.item_nodiscount_total);
  }

  updateTotal(response) {
    this.totalPrice.innerHTML = `${response.basket_total} ₽`;
    if (this.totalOldPrice) {
      this.totalOldPrice.innerHTML = `${response.basket_nodiscount_total} ₽`;
    }
  }

  updateProductCountsInBackground() {
    setTimeout(() => {
      document.dispatchEvent(new Event('update-product-counts'));
    }, 1000);
  }

  async request(url, data, method) {
    method = method || 'POST';
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(method, url);
      request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      data = data || {};
      data[this.csrfParam] = this.csrfToken;
      const formData = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
      }).join('&')

      request.onload = () => {
        let data = request.responseText;
        if (request.status >= 200 && request.status < 400) {
          data = JSON.parse(data);
          resolve(data, this.request);
        } else {
          reject(data, this.request);
        }
      };

      return request.send(formData);
    });
  }
}

document.addEventListener('openModalBasket', (e) => {
  new ModalBasket(e);
});

document.querySelectorAll('[data-open-modal-basket]').forEach((item) => {
  item.addEventListener('click', () => document.dispatchEvent(new Event('openModalBasket')));
});